import React from "react";
import PropTypes from "prop-types";

const Select = ({ selectProps, selectTitle, options, value, onChange, ariaLabel, inputId}) => (
  <select
    {...(selectTitle ? { "title": selectTitle } : {})}
    {...selectProps}
    className="form-control"
    value={value}
    {...(ariaLabel ? { "aria-labelledby": ariaLabel } : {})}
    {...(inputId ? {"id": inputId} : {})}
    onChange={onChange}
  >
    {options.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ))}
  </select>
);

Select.propTypes = {
  selectProps: PropTypes.object,
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

Select.defaultProps = {
  selectProps: {}
};

export default Select;
